import { ControlFacet } from '../models/controls/ControlFacet';

export interface ISignalData {
  signal: React.ReactNode;
  title?: string;
  key: string;
}

export const itemLifeCycleSignalsControl = new ControlFacet<{
  itemKey: string;
}, {
  signals: ISignalData[];
}>('itemLifeCycleSignalsControl');